import { useQuery } from '@tanstack/react-query';
import { getScheduledCoupons } from '@/services/credit-worker.service';
import type { ScheduledCoupon } from '@/types/collection.types';

interface UseScheduledCouponsReturn {
  coupons: ScheduledCoupon[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useScheduledCoupons(partnerId: string | undefined): UseScheduledCouponsReturn {
  const query = useQuery({
    queryKey: ['scheduled-coupons', partnerId],
    queryFn: () => getScheduledCoupons(partnerId!),
    enabled: !!partnerId,
    staleTime: 2 * 60 * 1000,
  });

  return {
    coupons: query.data?.data?.coupons ?? [],
    isLoading: query.isLoading,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
